var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{attrs:{"redirectWithLoginFailed":true}},[_c('Header',{attrs:{"content":_vm.headerContent}}),_c('NowLoading',{attrs:{"show":_vm.isSaving}}),_c('div',{staticClass:"wrap-slide"},[_c('ModuleAddSlide',{ref:"modeulAddSlide"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }